// Get the elements that are going to have a transition for the current device
const transitionClassPattern = /(?:(lg):)?transition-(\[?[a-z-]+\]?)/g;

export const getAnimatedElements = (nodes) =>
  [].concat(nodes).filter((el) => {
    let transitionsOnMobile = false;
    let transitionsOnDesktop = null;

    let execResult;
    // eslint-disable-next-line
    while ((execResult = transitionClassPattern.exec(el.className)) !== null) {
      const [, breakpoint, value] = execResult;

      if (breakpoint === 'lg') {
        transitionsOnDesktop = value !== 'none';
      } else {
        transitionsOnMobile = value !== 'none';
      }
    }

    // If only a mobile transition class is defined, then desktop is also animated
    if (transitionsOnDesktop === null) transitionsOnDesktop = transitionsOnMobile;

    return window.innerWidth >= 1024 ? transitionsOnDesktop : transitionsOnMobile;
  });

export default (nodes) =>
  Promise.all(
    getAnimatedElements(nodes).map(
      (node) =>
        new Promise((resolve) => {
          node.addEventListener('transitionend', resolve, { once: true });
        }),
    ),
  );
